import React from 'react';

import {
  List,
} from '@mui/material';

import type { TemperatureJson } from '@/types/domain/temperature/entities/temperatureEntity';

import CustomListItem from '@/components/CustomListItem';
import { MeasureDateTime } from '@/domain/temperature/service/entity/valueObjects/measureDateTime';
import { Temperature } from '@/domain/temperature/service/entity/valueObjects/temperature';
import { toStringDateTimeDisplay } from '@/utils/date';

const TemperatureInfo: React.FC<{
  /** データ */
  data: TemperatureJson,
}> = ({ data }) => {
  const {
    temperature,
    measureDateTime,
  } = data.data;
  return (
    <List>
      <CustomListItem
        name={MeasureDateTime.label}
        content={toStringDateTimeDisplay(new Date(measureDateTime), true)}
      />
      <CustomListItem
        name={Temperature.label}
        content={temperature.toString()}
      />
    </List>
  );
};

export default TemperatureInfo;
